/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

var block_call = false;

$(document).ready(function() {

  if($( window ).width() > 750) {
    setTimeout(
      function() {
          $('.site-header__navigation').trigger('click');
      }, 10
    );
  }
  else {
     $('.main-content').css('width', '100%').css('margin', '0px');
  }
  
  $(document).on('click', '.cart-drawer__close-button, .drawer-cover', function(e) {
	$('.site-header__navigation').trigger('click');
  });
  
  $(document).on('click', '.site-header__navigation', function(e) {
    var open = $(this).attr('aria-expanded');
    if(open === 'true') {
      setTimeout(
        function() {
          $('.main-content').css('width', '100%').css('margin', '0px');
        }, 500
      );
    }
    else {
      setTimeout(
        function() {
          $('.main-content').css('width', 'calc(100% - 250px)').css('margin-left', '250px');
        }, 100
      );
    }
  });
  
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: setInterval(function() {
    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');

    var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');

    var $slides = $('.slideshow__slide');

    var currentIndex = ($slides.index($slide) + 1) % $slides.length;

    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');

    var $buttons = $('.slideshow__button')
      .eq(currentIndex)
      .addClass('slideshow__button--active');

  }, 4000)

};
  
});